import type { ContentObjectList, ContentObjectView, NonEventContentObjectDetail } from 'models';
import type { ReactNode } from 'react';
import { Col, Row } from 'ui';
import { ActionBar } from './action-bar';
import { StatusBar } from './status-bar';

type P = {
  item: ContentObjectList | NonEventContentObjectDetail;
  onShowComments?: () => void;
  preview: ReactNode;
  view?: ContentObjectView;
};

const ContentObjectFooter = ({ item, onShowComments, preview, view = 'other' }: P) => (
  <Row className="content-object-footer" gutter={[0, 16]}>
    {view === 'bookmark' ? null : (
      <Col className="content-object-footer__status-bar" span={24}>
        <StatusBar item={item} onShowComments={onShowComments} />
      </Col>
    )}
    <Col span={24}>
      <ActionBar item={item} onShowComments={onShowComments} preview={preview} view={view} />
    </Col>
  </Row>
);

export default ContentObjectFooter;
